import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"

import { theme as defaultTheme, getTheme } from "themes/default/theme"
import "./base.css"
import { useThemeContext } from "contexts/ThemeContext"
import { useMemo } from "react"
import { GlobalStyles } from "@mui/material"

export const themes = {
  defaultTheme,
}

export const ThemeProvider = ({ children }) => {
  const { fontFamily, fontSize, bgColor, mode } = useThemeContext()
  // const themes = {
  //   defaultTheme: {
  //     ...defaultTheme,
  //     typography: {
  //       ...defaultTheme.typography,
  //       fontFamily: fontFamily,
  //     },
  //   },
  // }

  const theme = useMemo(
    () =>
      getTheme({
        fontFamily,
        fontSize,
        bgColor: mode === "light" ? bgColor : "#1d2329",
        mode,
      }),
    [fontFamily, fontSize, bgColor, mode]
  )

  return (
    <MuiThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          ":root": {
            "--app-font-family": fontFamily,
            "--app-font-size": `${parseInt(fontSize?.replace("px", "")) - 3}px`,
            "--app-bg-color": bgColor,
            "--app-mode": mode,
          },
        }}
      />
      {children}
    </MuiThemeProvider>
  )
}
